import { render } from "./ModalPic.vue?vue&type=template&id=478677c1"
import script from "./ModalPic.vue?vue&type=script&lang=js"
export * from "./ModalPic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__